var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lang-select" },
    [
      _c("span", { staticClass: "lang-text" }, [
        _vm._v(
          _vm._s(
            _vm.comCountryName(_vm.$store.getters.curCountry.country_code)
          ) + " "
        ),
        !["HK-USD", "ALL"].includes(_vm.$store.getters.curCountry.country_code)
          ? _c("span", [
              _vm._v(
                "(" +
                  _vm._s(
                    _vm.comCountryCurrency(
                      _vm.$store.getters.curCountry.country_code
                    )
                  ) +
                  ")"
              ),
            ])
          : _vm._e(),
      ]),
      _c(
        "el-dropdown",
        {
          staticClass: "international",
          attrs: { trigger: "click" },
          on: { command: _vm.handleSetLanguage },
        },
        [
          _c("div", [
            _c("i", { staticClass: "country-icon el-icon-s-data" }),
            _c("i", { staticClass: "el-icon-arrow-down icon-arrow-down" }),
          ]),
          _c(
            "el-dropdown-menu",
            { attrs: { slot: "dropdown" }, slot: "dropdown" },
            _vm._l(_vm.onlineCountryList, function (country) {
              return _c(
                "el-dropdown-item",
                {
                  key: country.code,
                  attrs: {
                    disabled:
                      _vm.$store.getters.curCountry.country_code ===
                      country.code,
                    command: country.code,
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.language === "zh"
                          ? country.cn_name
                          : country.en_name
                      ) +
                      " "
                  ),
                  !["HK-USD", "ALL"].includes(country.code)
                    ? _c("span", [
                        _vm._v(" (" + _vm._s(country.currency) + ") "),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }